var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNativeKeyboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-331d9838-f115-46e5-ab89-d92b298e0c9d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 32.838,
    y: 21.142,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.049,
    y: 21.142,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.891,
    y: 21.142,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.259,
    y: 21.142,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.47,
    y: 21.142,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.68,
    y: 21.142,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.838,
    y: 27.739,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.049,
    y: 27.739,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.891,
    y: 27.739,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.838,
    y: 34.336,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.891,
    y: 34.336,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.259,
    y: 27.739,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.47,
    y: 27.739,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.049,
    y: 34.336,
    width: 22.358,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.68,
    y: 27.739,
    width: 3.726,
    height: 3.726,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.445,18.684c1.142,0,2.071.929,2.071,2.071v18.49c0,1.142-.929,2.071-2.071,2.071H31.555c-1.142,0-2.071-.929-2.071-2.071v-18.49c0-1.142.929-2.071,2.071-2.071h36.89m0-2.484H31.555c-2.516,0-4.555,2.039-4.555,4.555v18.49c0,2.516,2.039,4.555,4.555,4.555h36.89c2.516,0,4.555-2.039,4.555-4.555v-18.49c0-2.516-2.039-4.555-4.555-4.555h0Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNativeKeyboard);
export default __webpack_public_path__ + "static/media/NativeKeyboard.2c53eaedf88db3856e9af48f44fa8119.svg";
export { ForwardRef as ReactComponent };